export default __webpack_public_path__ + "static/media/spiritualtorment.d045d321.png";